export const jobDescriptions = {
  'VP of Gov. Affairs': {
    title: 'Vice President of Government Affairs',
    overview: 'AG&WESTERN Rail Inc. is seeking an experienced Vice President of Government Affairs to lead our federal, state, and local government relations strategy. This executive role is critical to advancing our mission of expanding passenger and freight rail services across North America. You will serve as the primary liaison between AG&WESTERN and government entities, regulatory agencies, and policy makers.',
    responsibilities: [
      'Develop and execute comprehensive government affairs strategy at federal, state, and local levels',
      'Build and maintain relationships with elected officials, regulatory agencies, and transportation authorities',
      'Monitor and analyze legislative and regulatory developments affecting rail transportation',
      'Lead advocacy efforts for policies supporting rail infrastructure investment and modernization',
      'Coordinate with industry associations and coalition partners on policy initiatives',
      'Represent AG&WESTERN at government hearings, industry forums, and stakeholder meetings',
      'Manage government compliance requirements and reporting obligations',
      'Advise executive leadership on political and regulatory risks and opportunities'
    ],
    qualifications: [
      "Bachelor's degree in Political Science, Public Policy, Law, or related field (Master's or JD preferred)",
      '10+ years of experience in government affairs, public policy, or government relations',
      'Proven track record of successful advocacy with federal and state legislative bodies',
      'Deep understanding of transportation policy, infrastructure funding, and regulatory frameworks',
      'Established relationships with key government officials and regulatory agencies',
      'Excellent written and verbal communication skills',
      'Experience managing government affairs teams and budgets',
      'Ability to travel frequently to Washington, D.C. and state capitals'
    ],
    preferred: [
      'Previous experience in rail, transit, or transportation industry',
      'Background working in government, congressional office, or regulatory agency',
      'Experience with federal grant applications and infrastructure funding programs',
      'Knowledge of environmental and safety regulations affecting rail operations'
    ]
  },
  'CRO (Chief Revenue Officer)': {
    title: 'Chief Revenue Officer',
    overview: 'AG&WESTERN Rail Inc. is seeking a dynamic Chief Revenue Officer to drive revenue growth and optimize our commercial strategy. As CRO, you will lead all revenue-generating functions including sales, marketing, pricing, and customer success for both our passenger and freight rail services. This executive role requires a strategic thinker who can identify market opportunities and build sustainable revenue streams in a competitive transportation landscape.',
    responsibilities: [
      'Develop and execute comprehensive revenue growth strategy across passenger and freight services',
      'Lead sales, marketing, pricing, and business development teams',
      'Identify new market opportunities and strategic partnerships to expand service offerings',
      'Optimize pricing strategies to maximize revenue while maintaining competitive positioning',
      'Build and manage key customer relationships with corporate clients and government agencies',
      'Develop data-driven revenue forecasts and performance metrics',
      'Collaborate with operations to align capacity with revenue opportunities',
      'Drive customer acquisition, retention, and lifetime value strategies',
      'Oversee brand positioning and marketing campaigns',
      'Report revenue performance and strategic recommendations to Board of Directors'
    ],
    qualifications: [
      "Bachelor's degree in Business, Marketing, Economics, or related field (MBA preferred)",
      '12+ years of progressive revenue leadership experience',
      'Proven track record of driving significant revenue growth in B2B or transportation industry',
      'Experience managing multi-channel sales and marketing organizations',
      'Strong analytical skills with expertise in revenue analytics and forecasting',
      'Demonstrated success in strategic pricing and revenue optimization',
      'Excellent negotiation and relationship management skills',
      'Experience with CRM systems and revenue management tools'
    ],
    preferred: [
      'Experience in transportation, logistics, or infrastructure industries',
      'Background in both B2B and B2C revenue models',
      'Knowledge of government contracting and public-private partnerships',
      'Experience scaling revenue in high-growth or startup environments'
    ]
  },
  'CXO (Chief Experience Officer)': {
    title: 'Chief Experience Officer',
    overview: 'AG&WESTERN Rail Inc. is seeking a visionary Chief Experience Officer to shape and elevate the end-to-end customer experience across all touchpoints. This executive role is responsible for creating seamless, memorable experiences for both passenger and freight customers. You will lead the design and implementation of customer-centric strategies that differentiate AG&WESTERN in the competitive transportation market and build lasting customer loyalty.',
    responsibilities: [
      'Define and execute customer experience strategy across all passenger and freight services',
      'Lead customer experience, service design, and customer insights teams',
      'Map and optimize customer journeys from discovery through post-service engagement',
      'Establish customer experience metrics, NPS targets, and satisfaction benchmarks',
      'Drive digital transformation initiatives to enhance booking, ticketing, and tracking experiences',
      'Oversee station experience design, onboard amenities, and service quality standards',
      'Implement voice-of-customer programs and feedback loops',
      'Collaborate with operations to ensure service delivery meets experience standards',
      'Lead customer service training and culture development across the organization',
      'Champion accessibility and inclusive design principles'
    ],
    qualifications: [
      "Bachelor's degree in Business, Design, Marketing, or related field (Master's preferred)",
      '10+ years of experience in customer experience, service design, or related fields',
      'Proven track record of transforming customer experiences in service industries',
      'Strong understanding of customer journey mapping and experience design methodologies',
      'Experience with customer analytics, NPS programs, and satisfaction measurement',
      'Demonstrated ability to lead cross-functional teams and drive organizational change',
      'Excellent communication and stakeholder management skills',
      'Experience with digital experience platforms and customer engagement tools'
    ],
    preferred: [
      'Experience in transportation, hospitality, or travel industries',
      'Background in service design, design thinking, or user experience',
      'Knowledge of accessibility standards and inclusive design practices',
      'Experience managing both B2B and B2C customer experiences'
    ]
  },
  'COO (Chief Operating Officer)': {
    title: 'Chief Operating Officer',
    overview: 'AG&WESTERN Rail Inc. is seeking an accomplished Chief Operating Officer to oversee all operational aspects of our passenger and freight rail services. As COO, you will be responsible for the safe, efficient, and reliable operation of our rail network. This executive role requires exceptional operational expertise, strategic thinking, and the ability to lead large-scale operations while maintaining the highest standards of safety and service quality.',
    responsibilities: [
      'Lead all operational functions including train operations, maintenance, stations, and logistics',
      'Ensure safe, on-time, and reliable service delivery across passenger and freight networks',
      'Develop and implement operational strategies to improve efficiency and reduce costs',
      'Oversee fleet management, maintenance programs, and infrastructure investments',
      'Manage operational budgets, resource allocation, and capital planning',
      'Ensure compliance with FRA regulations and safety standards',
      'Lead incident response, safety investigations, and continuous improvement programs',
      'Collaborate with revenue and customer experience teams to align operations with business goals',
      'Manage relationships with partner railroads, Amtrak, and infrastructure owners',
      'Drive operational innovation through technology adoption and process optimization'
    ],
    qualifications: [
      "Bachelor's degree in Engineering, Operations Management, or related field (Master's preferred)",
      '15+ years of operations leadership experience in transportation or logistics',
      'Deep understanding of railroad operations, safety regulations, and industry standards',
      'Proven track record of managing complex, multi-site operations',
      'Strong financial acumen and budget management experience',
      'Experience with safety management systems and regulatory compliance',
      'Excellent problem-solving and crisis management skills',
      'Demonstrated ability to lead large operational teams'
    ],
    preferred: [
      'Previous experience as COO or VP of Operations in rail or transit industry',
      'FRA certification or deep knowledge of federal railroad regulations',
      'Experience with railroad dispatching, train control systems, and infrastructure',
      'Background in lean operations or continuous improvement methodologies'
    ]
  },
  'CLO (Chief Legal Officer)': {
    title: 'Chief Legal Officer',
    overview: 'AG&WESTERN Rail Inc. is seeking a strategic Chief Legal Officer to serve as the company\'s top legal advisor and lead our legal, regulatory, and compliance functions. As CLO, you will provide counsel on all legal matters affecting our passenger and freight rail operations, including contracts, regulatory compliance, litigation, risk management, and corporate governance. This executive role requires both legal expertise and business acumen to support AG&WESTERN\'s growth and protect its interests.',
    responsibilities: [
      'Serve as principal legal advisor to CEO, Board of Directors, and executive leadership',
      'Lead legal, compliance, regulatory affairs, and risk management teams',
      'Oversee all corporate legal matters including contracts, agreements, and transactions',
      'Manage regulatory compliance with FRA, FTA, DOT, and other federal/state agencies',
      'Direct litigation strategy and manage outside counsel relationships',
      'Advise on corporate governance, securities compliance, and board matters',
      'Review and negotiate major commercial agreements, partnerships, and joint ventures',
      'Oversee risk management programs and insurance strategies',
      'Lead legal aspects of mergers, acquisitions, and corporate transactions',
      'Ensure compliance with employment law, environmental regulations, and data privacy requirements'
    ],
    qualifications: [
      'Juris Doctor (JD) degree from accredited law school',
      'Active bar admission in relevant jurisdiction(s)',
      '12+ years of legal experience with at least 5 years in senior leadership role',
      'Experience as General Counsel or senior legal executive in regulated industry',
      'Strong understanding of corporate law, regulatory compliance, and commercial contracts',
      'Experience managing legal teams and outside counsel',
      'Excellent judgment, analytical skills, and business acumen',
      'Proven ability to provide strategic legal counsel to executive leadership and boards'
    ],
    preferred: [
      'Experience in transportation, rail, logistics, or infrastructure industries',
      'Background with federal regulatory agencies (FRA, DOT, FTA)',
      'Experience with government contracting and public-private partnerships',
      'Knowledge of labor and employment law in unionized environments',
      'Experience with corporate finance, securities, and capital markets transactions'
    ]
  },
  'Chairman of Board': {
    title: 'Chairman of the Board',
    overview: 'AG&WESTERN Rail Inc. is seeking an accomplished and visionary Chairman of the Board to provide strategic leadership and governance oversight. This prestigious role will guide the Board of Directors in setting the company\'s strategic direction, ensuring accountability, and representing AG&WESTERN to key stakeholders including investors, government officials, and industry partners.',
    responsibilities: [
      'Lead and manage Board of Directors meetings, setting agendas and ensuring effective governance',
      'Provide strategic guidance on company vision, mission, and long-term goals',
      'Serve as primary liaison between Board and executive leadership team',
      'Represent AG&WESTERN to investors, government officials, and key stakeholders',
      'Oversee board composition, succession planning, and director recruitment',
      'Ensure compliance with corporate governance best practices and regulatory requirements',
      'Lead board committees including audit, compensation, and nominating committees',
      'Support CEO and executive team on major strategic initiatives and critical decisions',
      'Champion corporate values, ethics, and stakeholder engagement'
    ],
    qualifications: [
      'Extensive board experience, preferably as Chairman or Lead Director',
      '20+ years of senior executive or board leadership experience',
      'Deep understanding of corporate governance, fiduciary duties, and regulatory compliance',
      'Proven track record of strategic leadership in large organizations',
      'Strong financial acumen and understanding of capital markets',
      'Exceptional communication and stakeholder management skills',
      'Experience overseeing CEO performance and executive compensation',
      'Demonstrated commitment to ethical leadership and corporate responsibility'
    ],
    preferred: [
      'Experience in transportation, infrastructure, or capital-intensive industries',
      'Background as CEO or C-suite executive of public or private company',
      'Government or public policy experience at senior level',
      'Network of relationships with institutional investors and industry leaders'
    ]
  },
  'CPO (Chief Product Officer)': {
    title: 'Chief Product Officer',
    overview: 'AG&WESTERN Rail Inc. is seeking an innovative Chief Product Officer to define and execute our product strategy across passenger and freight rail services. This executive role will drive product development, customer innovation, and service differentiation. You will lead the creation of new service offerings, digital products, and customer-facing technologies that position AG&WESTERN as the leader in modern rail transportation.',
    responsibilities: [
      'Define and execute product strategy and roadmap for passenger and freight services',
      'Lead product management, product design, and innovation teams',
      'Identify market opportunities and customer needs through research and data analysis',
      'Oversee development of new service offerings, routes, and customer experiences',
      'Drive digital product innovation including mobile apps, booking platforms, and tracking systems',
      'Collaborate with engineering and operations to bring products to market',
      'Establish product performance metrics and success criteria',
      'Manage product lifecycle from concept through launch and optimization',
      'Partner with marketing and sales to ensure successful product launches',
      'Stay ahead of industry trends and competitive landscape'
    ],
    qualifications: [
      'Bachelor\'s degree in Business, Engineering, Design, or related field (MBA or Master\'s preferred)',
      '12+ years of product management experience with 5+ years in executive leadership',
      'Proven track record of launching successful products in B2B or B2C markets',
      'Experience managing product teams in technology-driven environments',
      'Strong analytical skills with data-driven decision-making approach',
      'Expertise in customer research, user experience design, and agile methodologies',
      'Excellent communication and cross-functional collaboration skills',
      'Experience with digital transformation and platform development'
    ],
    preferred: [
      'Experience in transportation, mobility, or logistics industries',
      'Background in both physical services and digital product development',
      'Knowledge of rail operations and infrastructure constraints',
      'Experience scaling products in regulated industries'
    ]
  },
  'CDO (Chief Data Officer)': {
    title: 'Chief Data Officer',
    overview: 'AG&WESTERN Rail Inc. is seeking a strategic Chief Data Officer to lead our data strategy, analytics, and AI capabilities. This executive role will transform how we leverage data to optimize operations, enhance customer experiences, and drive business growth. You will build a data-driven culture and establish AG&WESTERN as an industry leader in applying advanced analytics and artificial intelligence to rail transportation.',
    responsibilities: [
      'Develop and execute comprehensive data strategy aligned with business objectives',
      'Lead data engineering, analytics, data science, and business intelligence teams',
      'Establish data governance framework, quality standards, and security policies',
      'Build advanced analytics capabilities for operations optimization and predictive maintenance',
      'Drive AI and machine learning initiatives to enhance safety, efficiency, and customer service',
      'Create data products and insights that inform strategic decision-making',
      'Oversee data infrastructure, platforms, and architecture',
      'Implement data monetization strategies and new revenue opportunities',
      'Ensure regulatory compliance with data privacy laws (GDPR, CCPA, etc.)',
      'Foster data literacy and analytics adoption across the organization'
    ],
    qualifications: [
      'Bachelor\'s degree in Computer Science, Statistics, Data Science, or related field (Master\'s or PhD preferred)',
      '12+ years of experience in data management, analytics, or data science leadership',
      'Proven track record of building and scaling data organizations',
      'Expertise in data architecture, data governance, and data quality management',
      'Experience with modern data technologies (cloud platforms, big data, ML/AI)',
      'Strong understanding of data privacy regulations and security best practices',
      'Excellent strategic thinking and business acumen',
      'Experience presenting to executive leadership and boards'
    ],
    preferred: [
      'Experience in transportation, logistics, or asset-intensive industries',
      'Background in operations research or supply chain optimization',
      'Knowledge of IoT, sensor data, and real-time analytics',
      'Experience with predictive maintenance and asset management analytics'
    ]
  },
  'CIO (Chief Information Officer)': {
    title: 'Chief Information Officer',
    overview: 'AG&WESTERN Rail Inc. is seeking a forward-thinking Chief Information Officer to lead our technology strategy and IT operations. This executive role is responsible for building and maintaining the technology infrastructure that enables our passenger and freight rail services. You will drive digital transformation, cybersecurity, and innovation while ensuring reliable, secure, and scalable technology systems that support business growth.',
    responsibilities: [
      'Develop and execute IT strategy aligned with business goals and growth plans',
      'Lead technology teams including infrastructure, applications, security, and support',
      'Oversee enterprise systems including ERP, CRM, operations, and customer-facing platforms',
      'Drive digital transformation initiatives and technology modernization programs',
      'Establish cybersecurity strategy, risk management, and compliance frameworks',
      'Manage IT budget, vendor relationships, and technology investments',
      'Ensure high availability and reliability of critical operational systems',
      'Lead cloud migration and hybrid infrastructure strategy',
      'Champion innovation through emerging technologies (AI, IoT, automation)',
      'Build technology partnerships and evaluate build vs. buy decisions'
    ],
    qualifications: [
      'Bachelor\'s degree in Computer Science, Information Systems, or related field (Master\'s preferred)',
      '15+ years of IT leadership experience with 8+ years in senior executive roles',
      'Proven track record of leading digital transformation in large organizations',
      'Deep expertise in enterprise architecture, cloud computing, and infrastructure',
      'Strong understanding of cybersecurity, data protection, and regulatory compliance',
      'Experience managing large IT teams and multi-million dollar budgets',
      'Excellent strategic planning and vendor management skills',
      'Strong business acumen and ability to align technology with business outcomes'
    ],
    preferred: [
      'Experience in transportation, logistics, or critical infrastructure industries',
      'Background with operational technology (OT) and industrial control systems',
      'Knowledge of rail operations, signaling systems, and safety-critical applications',
      'Experience with 24/7 operations and high-availability systems'
    ]
  },
  'CSO (Chief Security Officer)': {
    title: 'Chief Security Officer',
    overview: 'AG&WESTERN Rail Inc. is seeking a seasoned Chief Security Officer to lead all aspects of security across our rail operations, infrastructure, and corporate functions. This critical executive role encompasses physical security, cybersecurity, operational safety, and emergency response. You will ensure the protection of our passengers, employees, assets, and data while maintaining compliance with federal transportation security regulations.',
    responsibilities: [
      'Develop and execute comprehensive security strategy across physical and cyber domains',
      'Lead corporate security, cybersecurity, and emergency management teams',
      'Ensure compliance with TSA, DHS, and federal transportation security regulations',
      'Oversee physical security for rail stations, facilities, rolling stock, and infrastructure',
      'Establish cybersecurity programs including threat detection, incident response, and risk management',
      'Manage relationships with law enforcement, DHS, FBI, and intelligence agencies',
      'Develop emergency response plans and crisis management protocols',
      'Conduct security risk assessments and implement mitigation strategies',
      'Oversee security technology including surveillance, access control, and monitoring systems',
      'Lead security awareness training and culture development'
    ],
    qualifications: [
      'Bachelor\'s degree in Security Management, Criminal Justice, or related field (Master\'s preferred)',
      '15+ years of security experience with 8+ years in executive leadership',
      'Deep understanding of transportation security regulations and compliance requirements',
      'Experience integrating physical security and cybersecurity programs',
      'Background in law enforcement, military, intelligence, or federal security agencies preferred',
      'Strong understanding of critical infrastructure protection',
      'Excellent crisis management and emergency response capabilities',
      'Security certifications (CPP, PSP, CISSP, or similar) highly valued'
    ],
    preferred: [
      'Experience in rail, transit, aviation, or critical infrastructure security',
      'Background with TSA, DHS, FBI, or other federal security agencies',
      'Knowledge of operational technology (OT) and industrial control system security',
      'Experience with public-private security partnerships and information sharing'
    ]
  },
  'Office Secretary': {
    title: 'Office Secretary',
    overview: 'AG&WESTERN Rail Inc. is seeking a professional and highly organized Office Secretary to provide administrative support to our executive team. This role is essential to ensuring smooth daily operations through efficient management of schedules, correspondence, meetings, and office coordination. You will serve as the first point of contact for visitors and stakeholders while maintaining confidentiality and professionalism.',
    responsibilities: [
      'Provide administrative support to executives including calendar management and travel coordination',
      'Manage incoming calls, emails, and correspondence with professionalism',
      'Schedule and coordinate meetings, prepare agendas, and take meeting minutes',
      'Maintain filing systems, records, and confidential documents',
      'Greet visitors, clients, and vendors at the office',
      'Prepare reports, presentations, and business correspondence',
      'Order office supplies and coordinate with facilities management',
      'Support onboarding of new employees with administrative tasks',
      'Coordinate company events, meetings, and travel arrangements',
      'Handle sensitive information with discretion and confidentiality'
    ],
    qualifications: [
      'High school diploma required; Associate\'s degree or administrative certification preferred',
      '3+ years of experience in administrative or secretarial role',
      'Proficiency in Microsoft Office Suite (Word, Excel, PowerPoint, Outlook)',
      'Excellent written and verbal communication skills',
      'Strong organizational skills with attention to detail',
      'Ability to multitask and prioritize in fast-paced environment',
      'Professional demeanor and customer service orientation',
      'Discretion in handling confidential information'
    ],
    preferred: [
      'Experience supporting C-level executives',
      'Knowledge of office management systems and procedures',
      'Familiarity with transportation or logistics industry',
      'Bilingual capabilities (English and Spanish)'
    ]
  }
};
